import React, {useCallback, useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import {connect, useDispatch} from 'react-redux';
import ModalInfoForm from '../../components/Modal/newTemplates/ModalInfoForm/ModalInfoForm';
import LandingPageHeader from './LandingPageHeader';
import LandingNotification from './LandingNotification';
import {ActionRouteNavigate} from '../../store/actions/actions-route';
import {buildRoute} from '../../configs/routes';
import URL_MAP from '../../constants/urls';
import {t} from '../../services/i18nHandler';
import {LANDING_BLOCK_KEYS} from '../../constants/landing';
import {mediaSizes} from '../../configs/media';
import Sidebar from '../../components/Sidebar/Sidebar';
import Header from '../../components/Header/Header';
import HeaderInfo from '../../components/Header/HeaderInfo';

function LandingPageTools({
  settings, windowWidth, language, loggedIn, activeSlide, loading,
}) {
  const dispatch = useDispatch();

  const [showContactForm, setShowContactForm] = useState(false);

  const onOnlinePollClick = useCallback(() => {
    dispatch(ActionRouteNavigate(buildRoute(URL_MAP.ONLINE_POLL, settings.onlinePollKey || 'landing')));
  }, [settings]);

  const showHeader = useMemo(() => (LANDING_BLOCK_KEYS.INTRO !== activeSlide && !loading), [activeSlide, loading]);

  const showMobileHeader = useMemo(() => (windowWidth < mediaSizes.xl), [windowWidth]);

  return (
    <>
      {showContactForm && (
        <ModalInfoForm isOpen onClose={() => setShowContactForm(false)} />
      )}
      {!showMobileHeader && windowWidth > mediaSizes.xl && (
        <LandingPageHeader language={language} loggedIn={loggedIn} />
      )}
      {showMobileHeader && (
        <>
          <Sidebar />
          <Header />
          <HeaderInfo />
        </>
      )}
      {!loggedIn && (
        <LandingNotification
          title={t('onlinePoll.notifyTitle')}
          text={t('onlinePoll.notifyText')}
          btnText={t('onlinePoll.notifyBtn')}
          type="online-poll"
          onClick={onOnlinePollClick}
          windowWidth={windowWidth}
        />
      )}
      <LandingNotification
        position="left"
        type="details"
        title={t('aboutPlatformModalForm.notifyTitle')}
        text={t('aboutPlatformModalForm.notifyText')}
        btnText={t('aboutPlatformModalForm.notifyBtn')}
        onClick={() => setShowContactForm(true)}
        windowWidth={windowWidth}
      />
    </>
  );
}

LandingPageTools.defaultProps = {
  language: 'ru',
  loggedIn: false,
  loading: false,
  activeSlide: '',
  windowWidth: 0,
  settings: {},
};

LandingPageTools.propTypes = {
  language: PropTypes.string,
  loggedIn: PropTypes.bool,
  loading: PropTypes.bool,
  activeSlide: PropTypes.string,
  windowWidth: PropTypes.number,
  settings: PropTypes.shape({}),
};

function mapStateToProps({rSession}) {
  return {
    loggedIn: rSession.LOGGED_IN,
  };
}

export default connect(mapStateToProps)(LandingPageTools);
